{
  "version": 1,
  "asset_id": "39a6e809-a069-479d-9cd8-34c29ec66037",
  "project_id": "e1a64cc6-0fc8-4a5b-9036-8fa01cc3f811",
  "url": "/__l5e/assets-v1/39a6e809-a069-479d-9cd8-34c29ec66037/clip-img_2179.mp4",
  "r2_key": "a/v1/e1a64cc6-0fc8-4a5b-9036-8fa01cc3f811/39a6e809-a069-479d-9cd8-34c29ec66037/clip-img_2179.mp4",
  "original_filename": "clip-img_2179.mp4",
  "size": 354142,
  "content_type": "video/mp4",
  "created_at": "2026-08-01T22:32:55Z"
}
